import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import sectorActions from '../actions/sector'

export const useSector = () => {
  const data = useSelector((state) => {
    return get(state, 'app.sectorManagement')
  })

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(sectorActions, dispatch),
    [dispatch],
  )

  return {
    actions,
    data,
  }
}
